// extracted by mini-css-extract-plugin
export default {"OpcCredentials":"OpcCredentials_OpcCredentials__bbA0z"};